var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMessageLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62156 6.9353C5.5687 6.9353 2.2832 10.2208 2.2832 14.2737V31.8857C2.2832 35.9386 5.5687 39.2241 9.62156 39.2241H10.8565V43.129C10.8565 44.6094 12.4963 45.5015 13.7392 44.6973L21.4235 39.7251C21.6437 39.5826 21.8187 39.412 21.9516 39.2241H43.378C47.4308 39.2241 50.7163 35.9386 50.7163 31.8857V14.2737C50.7163 10.2208 47.4308 6.9353 43.378 6.9353H9.62156Z",
    fill: "url(#paint0_linear_7240_24125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2659 20.7334H18.3326C17.1543 20.7334 16.1992 21.6885 16.1992 22.8667V30.3334C16.1992 31.5116 17.1543 32.4667 18.3326 32.4667H33.2659C34.4441 32.4667 35.3992 31.5116 35.3992 30.3334V22.8667C35.3992 21.6885 34.4441 20.7334 33.2659 20.7334Z",
    fill: "url(#paint1_linear_7240_24125)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4658 20.7335V16.4669C20.4658 15.0524 21.0277 13.6958 22.0279 12.6956C23.0281 11.6954 24.3847 11.1335 25.7992 11.1335C27.2136 11.1335 28.5702 11.6954 29.5704 12.6956C30.5706 13.6958 31.1325 15.0524 31.1325 16.4669V20.7335",
    stroke: "white",
    strokeWidth: 2.13333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_24125",
    x1: 2.2832,
    y1: 9.87067,
    x2: 44.1121,
    y2: 40.6917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EFD8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7240_24125",
    x1: 17.2659,
    y1: 20.7334,
    x2: 34.3326,
    y2: 35.1334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8235FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3479FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageLocked);
export default __webpack_public_path__ + "static/media/icon_message_locked.671dabdd7f4c2fa29e9d7bb3a437532d.svg";
export { ForwardRef as ReactComponent };